// Incoterms 2020
export const INCOTERMS = [
  { code: "EXW", label: "EXW — Ex Works" },
  { code: "FCA", label: "FCA — Free Carrier" },
  { code: "FAS", label: "FAS — Free Alongside Ship" },
  { code: "FOB", label: "FOB — Free on Board" },
  { code: "CFR", label: "CFR — Cost and Freight" },
  { code: "CIF", label: "CIF — Cost, Insurance and Freight" },
  { code: "CPT", label: "CPT — Carriage Paid To" },
  { code: "CIP", label: "CIP — Carriage and Insurance Paid To" },
  { code: "DAP", label: "DAP — Delivered at Place" },
  { code: "DPU", label: "DPU — Delivered at Place Unloaded" },
  { code: "DDP", label: "DDP — Delivered Duty Paid" },
];

export const COUNTRIES = [
  "Australia", "New Zealand", "United States", "United Kingdom", "Canada", "Ireland",
  "Germany", "France", "Netherlands", "Belgium", "Spain", "Italy", "Portugal", "Switzerland",
  "Austria", "Sweden", "Norway", "Denmark", "Finland", "Poland", "Czech Republic", "Greece",
  "Singapore", "Malaysia", "Indonesia", "Thailand", "Vietnam", "Philippines", "Japan",
  "South Korea", "China", "Hong Kong", "Taiwan", "India", "Pakistan", "Bangladesh",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Israel", "Turkey", "South Africa",
  "Kenya", "Nigeria", "Egypt", "Brazil", "Argentina", "Chile", "Colombia", "Mexico", "Peru",
];

// Currencies offered across the app (USD & AUD prioritised). Codes match backend fx.py.
export const gstRateFor = (customer) => {
  const k = (customer?.country || "").trim().toLowerCase();
  if (!k) return null;
  return ["australia", "au", "aus"].includes(k) ? 10 : 0;
};

export const CURRENCIES = [
  { code: "USD", label: "USD — US Dollar" },
  { code: "AUD", label: "AUD — Australian Dollar" },
  { code: "EUR", label: "EUR — Euro" },
  { code: "GBP", label: "GBP — British Pound" },
  { code: "NZD", label: "NZD — New Zealand Dollar" },
  { code: "CAD", label: "CAD — Canadian Dollar" },
  { code: "JPY", label: "JPY — Japanese Yen" },
  { code: "CHF", label: "CHF — Swiss Franc" },
  { code: "CNY", label: "CNY — Chinese Yuan" },
  { code: "SGD", label: "SGD — Singapore Dollar" },
  { code: "HKD", label: "HKD — Hong Kong Dollar" },
  { code: "INR", label: "INR — Indian Rupee" },
  { code: "ZAR", label: "ZAR — South African Rand" },
  { code: "SEK", label: "SEK — Swedish Krona" },
  { code: "NOK", label: "NOK — Norwegian Krone" },
  { code: "DKK", label: "DKK — Danish Krone" },
];

// Business-Central-style code suggestion: first 3 letters of the first word + last 3 of the name
export function suggestCode(name) {
  const n = (name || "").trim();
  if (!n) return "";
  const firstWord = n.split(/\s+/)[0];
  const first3 = firstWord.replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
  const alnum = n.replace(/[^A-Za-z0-9]/g, "");
  const last3 = alnum.slice(-3).toUpperCase();
  return (first3 + last3) || alnum.slice(0, 6).toUpperCase();
}
